import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { DELETE_FAVORITES_OVERLAY } from "shared/context/overlay/types"
import { useEvent } from "shared/lib/useEvent"
import { useOverlay } from "shared/lib/useOverlay"

import { FAVORITES_PROJECT_ID } from "entities/favorites/api/useFavoriteMutations"
import { useFavorites } from "entities/projects/api/useFavorites"
import { fullProjectPermissions } from "entities/projects/types/ProjectPermissions"
import { useProductPositionActionHandlers } from "features/product-position-management/model/useProductPositionActionHandlers"
import { ProductPositionsActionsOverlayViewModel } from "widgets/product-position/product-position-actions-overlay/ProductPositionActionsOverlayView"

import { FavoriteActionsOverlayConnectorProps } from "../FavoriteActionsOverlayConnector"

export function useFavoriteActionsOverlayModel({
  payload: { productPosition }
}: FavoriteActionsOverlayConnectorProps): ProductPositionsActionsOverlayViewModel {
  const { closeOverlay } = useCurrentOverlay()
  const { duplicateFavorite } = useFavorites()
  const { openOverlay: deleteFavoritesOverlay } = useOverlay(
    DELETE_FAVORITES_OVERLAY
  )

  const handleDelete = useEvent(() => {
    deleteFavoritesOverlay({ itemIDsToDelete: [productPosition.id] })
    closeOverlay()
  })

  const handleDuplicate = useEvent(() => {
    closeOverlay()
    return duplicateFavorite(productPosition.id)
  })

  const { onEdit, onCopy, onEditConfiguration, onAddClarificationRequest } =
    useProductPositionActionHandlers({
      projectID: FAVORITES_PROJECT_ID,
      productPosition,
      permissions: fullProjectPermissions,
      onAction: closeOverlay
    })

  return {
    onEdit,
    onDelete: handleDelete,
    onDuplicate: handleDuplicate,
    onCopy,
    onAssignAttachments: undefined,
    onAddClarificationRequest,
    onClose: closeOverlay,
    onEditConfiguration,
    onSelectInstallationReferences: undefined
  }
}
